import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ExcFileItem} from 'exc-upload-v2';
import {ExcRestService} from 'exc-rest-v2';
import {EnumerationService} from '../../../services/enumeration.service';
import {ApplicationService} from '../../../services/application.service';
import {NestedTreeControl} from '@angular/cdk/tree';

@Component({
  selector: 'app-modal-message-attachment-selector',
  templateUrl: './modal-message-attachment-selector.component.html',
  styles: []
})
export class ModalMessageAttachmentSelectorComponent extends ExcTranslation implements OnInit {
  @Input() data: any;
  attachment: any[] = [];
  attachmentObjects: any[] = [];

  ConfigAttachmentTable = {
    treeControl: new NestedTreeControl<any>(node => node.documents),
    dataSource: [] as any[],
    hasChild: (_: number, node: any) => !!node.documents && node.documents.length > 0
  };

  attachmentList = {
    selectKey: 'dokID',
    selected: [] as any[],
    selectedObjects: [] as any[]
  };

  constructor(
    private modalService: ExgModalService, private excRestService: ExcRestService,
    public enumSvc: EnumerationService, public appSvc: ApplicationService
  ) {
    super();
  }

  ngOnInit(): void {
    this.attachmentList.selectedObjects.length = this.attachmentList.selected.length = 0;
    this.attachmentList.selected.push(...this.data.attachmentLink);
    this.attachmentList.selectedObjects.push(...this.data.attachmentLinkObjects);
    this.ConfigAttachmentTable.dataSource = this.data.attachmentJagData; // .filter((folder: any) => folder.source !== 'report');
    this.attachment.length = this.attachmentObjects.length = 0;
    this.attachment.push(...this.data.attachment);
    this.attachmentObjects.push(...this.data.attachmentObjects);
  }

  isSelected(node: any): boolean {
    return this.attachmentList.selected.includes(node.dokID);
  }

  toggleSelection(node: any): void {
    const index = this.attachmentList.selected.indexOf(node.dokID);
    if (index > -1) {
      this.attachmentList.selected.splice(index, 1);
      const objIndex = this.attachmentList.selectedObjects.findIndex(obj => obj.dokID === node.dokID);
      if (objIndex > -1) {
        this.attachmentList.selectedObjects.splice(objIndex, 1);
      }
    } else {
      this.attachmentList.selected.push(node.dokID);
      this.attachmentList.selectedObjects.push(node);
    }
  }

  close(): void {
    this.modalService.close();
  }

  save(): void {
    this.modalService.action({
      attachmentLink: this.attachmentList.selected,
      attachmentLinkObjects: this.attachmentList.selectedObjects,
      attachment: this.attachment,
      attachmentObjects: this.attachmentObjects
    });
  }

  onFilesSelected(files: ExcFileItem[]): void {
    this.attachment = [];
    const fd: any = ExcFileItem.getFormData(files, {});
    this.excRestService.post(
      this.excRestService.computeUrl('MessageAttachmentC', {msgID: this.data.msgID}), fd
    ).subscribe((ret: any) => {
      if (ret && ret.success) {
        this.attachmentObjects = ret.data;
        this.attachmentObjects.forEach((e: any) => {
          this.attachment.push({ID: e.dokID});
        });
      }
    });
  }

  onAttachmentFileChipClose($event: { item: any; index: number }): void {
    this.attachmentObjects.splice($event.index, 1);
    this.attachment.splice($event.index, 1);
  }
}
